import { render, staticRenderFns } from "./DSPCampaignCharts.vue?vue&type=template&id=2c0813c4&"
import script from "./DSPCampaignCharts.vue?vue&type=script&lang=js&"
export * from "./DSPCampaignCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports